jQuery(function () {

  jQuery('body').on('click', '.homepage-header__nav-link', function (e) {
    e.preventDefault();
    var $this = jQuery(this);

    // Reset all content to be hidden
    jQuery('.homepage-header__overlay--active').removeClass('homepage-header__overlay--active');
    jQuery('.homepage-header__background').removeClass('homepage-header__background--active');
    jQuery('.homepage-header__content').removeClass('homepage-header__content--active');
    jQuery('.homepage-header__nav-link').removeClass('homepage-header__nav-link--selected');

    // Switch the active link
    $this.addClass('homepage-header__nav-link--selected');

    // Determine which slide to activate
    var id = $this.data('slide-id');
    jQuery('.homepage-header__background[data-slide-id="' + id + '"]').addClass('homepage-header__background--active');
    jQuery('.homepage-header__overlay').addClass('homepage-header__overlay--active');
    jQuery('.homepage-header__content[data-slide-id="' + id + '"]').addClass('homepage-header__content--active');

    //Set focus to heading (AODA)
    $(".homepage-header__content--active #sr_content").removeAttr("tabindex");
    setTimeout(function(){ $(".homepage-header__content--active #sr_content").attr("tabindex","-1").focus(); }, 200);

    return false;
  });

  // * Responsive Page Header -> START
  function responsiveBg() {

    var isMobile = window.matchMedia("(max-width: 599px)").matches;
    var $homepageHeaderImg = jQuery(".homepage-header img");
    var $pageHeaderBg = jQuery(".page-header__background");
    var $pageHeaderSliderBg = jQuery(".page-header-slider__image");
    var $pageHeaderSlideImg = jQuery(".page-header-slider__slide img");
    var $pageDataDesktop = $pageHeaderBg.attr("data-bg-desktop");
    var $pageDataMobile = $pageHeaderBg.attr("data-bg-mobile");

       function ifMobile(el) {
         el.each(function () {
           if (typeof jQuery(this).attr("data-bg-mobile") !== 'undefined') {
             isMobile && jQuery(this).attr("data-bg-mobile").length > 0 ? jQuery(this).attr("src", jQuery(this).attr("data-bg-mobile")) : jQuery(this).attr("src", jQuery(this).attr("data-bg-desktop"))
           }
         });
       }

    // * Homepage header
    if ($homepageHeaderImg.length) {
      ifMobile($homepageHeaderImg);
    }

    // * Page header
    if ($pageDataDesktop) {
      if ($pageHeaderBg.length) {
        if (isMobile && $pageDataMobile.length > 0) {
          $pageHeaderBg.attr("style", "background-image:url('" + $pageHeaderBg.attr("data-bg-mobile") + "');");
        } else {
          $pageHeaderBg.attr("style", "background-image:url('" + $pageDataDesktop + "');");
        }
      }
    }

    // * Page header slider
    if ($pageHeaderSliderBg) {
      if ($pageHeaderSlideImg.length) {
        ifMobile($pageHeaderSlideImg);
      }
    }

  }

  responsiveBg();

  jQuery(window).on("resize", function () {
    responsiveBg();
  });
  // * Responsive Page Header -> END

});